module.exports = __webpack_public_path__ + "img/default.0ce5020c.gif";